export default "__VITE_ASSET__BFnqsLJQ__"